var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", [
    _c("div", { staticClass: "layer2" }),
    _vm._v(" "),
    _c("div", { staticClass: "layer3" }),
    _vm._v(" "),
    _c("div", { staticClass: "top" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between" },
        [
          _c("router-link", { attrs: { to: "/" } }, [
            _c("div", { staticClass: "d-flex brand-box" }, [
              _c("div", { staticClass: "logo" }),
              _vm._v(" "),
              _c("div", { staticClass: "logo2" })
            ])
          ]),
          _vm._v(" "),
          _c("TopNavigation")
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "title", style: "width:" + _vm.titleWidth }, [
      _c("div", [_c("h1", [_vm._v(_vm._s(_vm.title))])])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ace0dc4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ace0dc4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/pages/layout/static/Header.vue
// module id = null
// module chunks = 